import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { isTaseronRole } from "./roles";
import { readJson, writeJson, removeKey } from "./storage";

// Son çalışılan ekran (kullanıcı bazlı, localStorage): sayfa yenilenip "/" adresine düşünce ya da tekrar girişte Genel Bakış yerine aynı ekrana dönülür
const KEY = "pas.lastRoute";
const SKIP = new Set(["/", "/login"]);
const LABELS = {
  "/dashboard": "Dashboard & Özet", "/veri-girisi": "Veri Girişi", "/veri-girisi?bolum=hizmet": "Hizmet Veri Girişi", "/veri-girisi?bolum=personel": "Personel Girişi", "/veri-girisi?bolum=fatura": "Fiş/Fatura Girişleri",
  "/veri-girisi?bolum=cek": "Verilen Çekler", "/veri-girisi?bolum=kredi": "Limit Risk / Banka Kredileri / Kredi Kartları", "/veri-girisi?bolum=maliyet": "Proje Maliyetleri Veri Girişi",
  "/izin-takvimi": "İzin Takvimi", "/onaylar": "Hizmet Onayları", "/is-emirleri": "İş Emirleri", "/atm-silim": "ATM Silim", "/musteri-hakedis": "Müşteri Hakedişi", "/taseron-hakedis": "Taşeron Hakedişi", "/proje-maliyet": "Proje Maliyet Özeti", "/satis-pazarlama": "Satış Pazarlama",
  "/odeme-plani": "Ödeme Planı", "/butce": "Bütçe", "/kesilen-faturalar": "Kesilen Faturalar", "/demirbaslar": "Demirbaşlar", "/demirbas": "Demirbaş Kartı", "/stoklar": "Stoklar", "/mali-veriler": "Mali Veriler",
  "/tanimlar/tatiller": "Resmi Tatiller", "/tanimlar/projeler": "Projeler", "/tanimlar/hizmetler": "Hizmetler", "/tanimlar/butce-kalemleri": "Bütçe Kalemleri", "/tanimlar/sabit-tanimlar": "Sabit Tanımlar", "/tanimlar/kullanicilar": "Kullanıcılar", "/tanimlar/yetki-matrisi": "Rol Yetki Matrisi", "/tanimlar/yedek": "Yedek Al",
  "/cariler": "Cari Listesi", "/taseronlar": "Taşeronlar", "/sifre-degistir": "Şifre Değiştir",
};

export function RouteMemory() {
  const { pathname, search } = useLocation();
  const { user } = useAuth();
  useEffect(() => { if (user && !SKIP.has(pathname)) writeJson(KEY, { path: pathname + search, at: Date.now(), user: user.email }, localStorage); }, [pathname, search, user]);
  return null;
}

// Son ekran kaydı: {path, at, user}; kullanıcı verilmişse yalnız aynı kullanıcıya ait kayıt döner
export function lastRoute(user) {
  const d = readJson(KEY, null, localStorage);
  if (!d?.path || !d.path.startsWith("/") || SKIP.has(d.path.split("?")[0])) return null;
  if (user?.email && d.user && d.user !== user.email) return null;
  return d;
}
export const forgetLastRoute = () => removeKey(KEY, localStorage);

export function homeRoute(user) {
  if (isTaseronRole(user?.role)) return "/is-emirleri";
  return lastRoute(user)?.path || "/dashboard";
}

export function routeLabel(path) {
  const [p, qs] = String(path || "").split("?");
  const bolum = new URLSearchParams(qs || "").get("bolum");
  if (bolum && LABELS[`${p}?bolum=${bolum}`]) return LABELS[`${p}?bolum=${bolum}`];
  if (LABELS[p]) return LABELS[p];
  const pre = Object.keys(LABELS).find((k) => !k.includes("?") && p.startsWith(`${k}/`));
  return pre ? LABELS[pre] : p;
}
